import { Component, Input } from '@angular/core';
import { WorldMapFeature } from '../../models/worldmap-model';

import { ZoomTransformation } from '../../../common/zoom/models/zoom-model';
import { ZoomConfig } from '../../../common/zoom/zoom-controls/zoom-controls.component';

import { growthColorScale } from '../../../helpers/chartHelpers';

import { CommonModule } from '@angular/common';
import * as d3 from 'd3';

@Component({
  selector: '[chart-symbol]',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg:g class="symbol">
      <svg:defs>
        <svg:marker
          [attr.id]="id"
          viewBox="0 0 10 10"
          refX="5"
          refY="5"
          [attr.markerWidth]="arrowSize"
          [attr.markerHeight]="arrowSize"
          orient="auto-start-reverse"
        >
          <svg:path class="symbol-marker-white" [attr.fill]="color" d="M 0 0 L 10 5 L 0 10 Z" [attr.stroke-width]="strokeWidth + 0.4" />
          <svg:path class="symbol-marker" [attr.fill]="color" d="M 0 0 L 10 5 L 0 10 Z" />
        </svg:marker>
      </svg:defs>

      <svg:g
        class="symbol-wrapper"
        [attr.transform]="'translate(' + feature.centroid[0] + ',' + feature.centroid[1] + ') rotate(' + angle + ')'"
      >
        <svg:line class="symbol-line-white" x1="0" x2="0" y1="0" [attr.y2]="lineSize" [attr.stroke-width]="strokeWidth + 0.4"></svg:line>

        <svg:line
          class="symbol-line"
          x1="0"
          x2="0"
          y1="0"
          [attr.stroke]="color"
          [attr.marker-end]="'url(#' + id + ')'"
          [attr.stroke-width]="strokeWidth"
          [attr.y2]="lineSize"
        ></svg:line>
      </svg:g>
    </svg:g>
  `,
  styleUrls: ['./symbol.component.scss']
})
export class SymbolComponent {
  @Input()
  colors: Array<string>;

  @Input()
  feature: WorldMapFeature;

  @Input()
  dataRange: Array<number>;

  @Input()
  set transform(transform: ZoomTransformation) {
    //  When zoom changes the scale we need to scale our symbols to make it easy to visualize!
    const scale = d3.scaleLinear().domain([ZoomConfig.ZOOM_MIN, ZoomConfig.ZOOM_MAX]);

    if (!transform || !transform.k) {
      return;
    }
    this.lineSize = scale.range([13, 3])(transform.k);
    this.arrowSize = scale.range([5, 3])(transform.k);
    this.circleSize = scale.range([2, 0.5])(transform.k);
    this.strokeWidth = scale.range([1, 0.3])(transform.k);
  }

  /**
   * The country growth is expecting a radian information to rotate the arrows
   */
  @Input()
  set countryGrowth(countryGrowth: number) {
    if (countryGrowth && this.dataRange) {
      this.id = `marker-${Math.random()}`;

      this.angle = countryGrowth;

      //  we need to revert the colors for now
      const colorsReverted = this.colors.map((c) => c);
      colorsReverted.reverse();
      this.color = growthColorScale(this.dataRange, countryGrowth, colorsReverted);
    }
  }

  //  Public variables to draw the symbols
  public angle: number = 0;
  public color: string;
  public id: string;

  // Arrow sizes
  public lineSize: number;
  public arrowSize: number;
  public circleSize: number;
  public strokeWidth: number;
}
